var _script, _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaOborot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _script || (_script = /*#__PURE__*/React.createElement("script", {
    xmlns: "",
    async: "false",
    type: "text/javascript",
    src: "moz-extension://33d4f970-0f6d-4e56-ae9a-a8614e04c84f/in-page.js"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0F5883;}\n\t.st1{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,120H10.3C4.6,120,0,115.4,0,109.7V10.3C0,4.6,4.6,0,10.3,0h99.4c5.7,0,10.3,4.6,10.3,10.3v99.4  C120,115.4,115.4,120,109.7,120z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.5,67.8c-1.2,5.8-3.7,10.7-7.6,14.8c-5.6,5.9-12.7,8.8-21.1,8.8c-8.5,0-15.4-2.9-21-8.7  C33.3,77,30.5,69.4,30.5,60c0-9.1,2.8-16.6,8.4-22.4c5.6-5.8,12.6-8.8,21-8.8c8.6,0,15.6,2.9,21.2,8.7c2.8,2.9,4.8,6.3,6.2,10  l-7.7,7.7l36.3-0.1V18.9l-9.2,9.2c-4.8-7-10.9-12.7-18.5-17.1C79.1,6,69.6,3.4,59.4,3.4c-14,0-26.5,4.9-37.3,14.6  C9.8,29.3,3.6,43.3,3.6,60.1c0,15.7,5.5,29,16.4,40c10.9,11,24.1,16.5,39.5,16.5c10.5,0,20.1-2.5,28.8-7.5  c8.7-5,15.6-11.9,20.6-20.7c3.7-6.5,6.1-13.4,7-20.6H88.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaOborot);
export default __webpack_public_path__ + "static/media/media_oborot.7635e1c6b5216ccce8b4ee81bae87cd6.svg";
export { ForwardRef as ReactComponent };